(function () {
  // Ordered longest-first so "white gold" / "rose gold" match before plain "gold".
  var FINISH_KEYWORDS = ['white gold', 'rose gold', 'silver', 'gold'];

  function detectFinish(text) {
    if (!text) return null;
    var lower = text.toLowerCase();
    for (var i = 0; i < FINISH_KEYWORDS.length; i++) {
      if (lower.indexOf(FINISH_KEYWORDS[i]) !== -1) return FINISH_KEYWORDS[i];
    }
    return null;
  }

  function getSelectedFinish(container) {
    var radios = container.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      var finish = detectFinish(radios[i].value);
      if (finish) return finish;
    }
    return null;
  }

  function filterMediaGallery(gallery, selectedFinish) {
    if (!gallery || !selectedFinish) return;

    var slides = gallery.querySelectorAll('.product__media-item');
    if (!slides.length) return;

    var slideFinishes = [];
    var anyFinishFound = false;
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      var finish = img ? detectFinish(img.getAttribute('alt')) : null;
      slideFinishes.push(finish);
      if (finish) anyFinishFound = true;
    });

    // If this product's photos never mention a finish, leave the gallery alone.
    if (!anyFinishFound) return;

    var firstVisibleId = null;
    slides.forEach(function (slide, i) {
      var finish = slideFinishes[i];
      var shouldHide = finish && finish !== selectedFinish;
      if (shouldHide) {
        slide.setAttribute('data-finish-hidden', 'true');
        slide.style.display = 'none';
        slide.classList.remove('is-active');
      } else {
        slide.removeAttribute('data-finish-hidden');
        slide.style.display = '';
        if (!firstVisibleId) firstVisibleId = slide.id;
      }
    });

    // Make sure exactly one visible slide is marked active (the first visible one),
    // unless a visible slide is already active.
    var activeVisible = gallery.querySelector('.product__media-item.is-active:not([data-finish-hidden])');
    if (!activeVisible && firstVisibleId) {
      var target = gallery.querySelector('#' + CSS.escape(firstVisibleId));
      if (target) target.classList.add('is-active');
    }

    // Filter matching thumbnails, if the layout has a thumbnail strip.
    var thumbs = gallery.querySelectorAll('.thumbnail-list__item');
    var visibleCount = 0;
    thumbs.forEach(function (thumb) {
      var targetId = thumb.getAttribute('data-target');
      var slide = targetId ? gallery.querySelector('#' + CSS.escape(targetId)) : null;
      var hidden = slide && slide.hasAttribute('data-finish-hidden');
      thumb.style.display = hidden ? 'none' : '';
      if (!hidden) visibleCount += 1;
    });

    if (visibleCount === 0) {
      // No thumbnail strip on this layout — count visible main slides instead.
      visibleCount = Array.prototype.filter.call(slides, function (slide) {
        return !slide.hasAttribute('data-finish-hidden');
      }).length;
    }

    var counter = gallery.querySelector('.slider-counter--total');
    if (counter) counter.textContent = visibleCount;
  }

  function runFilterForForm(form) {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var finish = getSelectedFinish(form);
    if (finish) filterMediaGallery(gallery, finish);
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('input[type="radio"]')) {
      var form = event.target.closest('form') || document;
      runFilterForForm(form);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    runFilterForForm(document);
  });

  // Product pages that swap sections via fetch (quick add, variant re-render) —
  // re-run once those updates settle.
  document.addEventListener('variant:change', function () {
    runFilterForForm(document);
  });
})();
